// extracted by mini-css-extract-plugin
export default {"description":"AbilityWelcome-module__description__TOufa","paragraph":"AbilityWelcome-module__paragraph__1oSGN"};